import React from 'react';
import { Select } from 'semantic-ui-react';

import AuthContext from '../../context/AuthContext';

class IntegrationSyncSelect extends React.Component {
  state = {options: []};

  render() {
    const { oauthToken, queryUrl } = this.props;
    const { options } = this.state;
    //window.Sfdc.canvas.client.targetOrigin = queryUrl.substring(0, queryUrl.indexOf('/services/'));
    //window.Sfdc.canvas.oauth.targetOrigin('https://ds-bolt-dev-ed.my.salesforce.com')
    //window.Sfdc.canvas.oauth.instance('00D36000000J4FsEAK');
    //	window.Sfdc.canvas.client.token(oauthToken);
/*
    window.Sfdc.canvas.client.ajax('https://ds-bolt-dev-ed.my.salesforce.com/services/data/v20.0/query/?q=SELECT+name+from+Account', {
      client: {oauthToken, instanceId: '06P36000000MCth', targetOrigin: 'https://ds-bolt-dev-ed.my.salesforce.com', instanceUrl: 'https://ds-bolt-dev-ed.my.salesforce.com'},
      headers: {
        'SalesforceProxy-Endpoint': 'https://ds-bolt-dev-ed.my.salesforce.com/services/data/v20.0/query/',
        'Authorization': `OAuth ${oauthToken}`,
        'Accept': 'application/json',
      },
      success(e) {
        console.dir(e);
      },
    });
*/
    return (
      <Select placeholder="..." options={options} />
    );
  }
}

export default IntegrationSyncSelect;
